export default async function sendOrder({ props, state, graphql }) {
  const { orderId, message } = state.get(`basket`)
  const tags = state.get('basket.receivers.tags')
  const unit = state.get('basket.unit')

  const receivers = Object.keys(tags).map(key => {
    const email = tags[key]
    return `"${email.label}"`
  })

  await graphql.mutate(
    `{processOrder(orderId: "${orderId}", unit: "${unit}", message: "${message.value.replace(
      /\n/g,
      '\\n'
    )}", receivers: [${receivers.join()}])}`
  )
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/sendOrder.js